import React, { PureComponent } from "react"

/* Components */
import { Chip } from '../components'

/* Constants */
import { env, utils, sound } from '../constants'

/* Picture */
import { Picture } from "../components"

/* UUID */
const { v4: uuidv4 } = require('uuid')

/* FIELDS */
const tempBoxStake = { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }
const initialStakes = [tempBoxStake, tempBoxStake, tempBoxStake, tempBoxStake, tempBoxStake]


/* Widget Chips */
class Chips extends PureComponent {

    constructor() {
        super()

        this.state = {
            list: []
        }
    }

    setChip = (value, index) => {

        const { boxPlayers, playerId, stakes, setStakes, total, selected, setSelected, list, setList, balance, game, currency, volume } = this.props

        if (selected !== index) {
            setSelected(index)
            if (volume) {
                sound.play('selectchip', 0.2)
            }
        }
        else {

            if (total + parseInt(value) > balance) {
                utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
                return
            }

            let cnt = 0

            const uuid = uuidv4()

            let tempStakes = [...stakes]
            tempStakes.forEach((stake, index) => {
                if (stake && boxPlayers && boxPlayers[index] && boxPlayers[index].playerId === playerId) {
                    if (stake.ante + parseInt(value) <= game.max) {
                        stake.ante += parseInt(value)

                        list.push({ value, type: "add", target: "ante", place: `ante-${index}`, uuid, box: index })
                        cnt += 1
                    }

                    if (volume) {
                        sound.play('sound', 0.2)
                    }

                }
            })

            if (cnt) {
                setList(list)
                setStakes(tempStakes)
            }

        }

    }

    clear = () => {
        const { setStakes, setList, volume } = this.props
        setStakes([{ ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }, { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }, { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }, { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }, { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }])
        setList([])

        if (volume) {
            sound.play('chip2', 0.2)
        }
    }

    cancel = () => {
        const { stakes, setStakes, list, setList, volume } = this.props
        let cancel = list

        const index = list.findLastIndex(e => e.type === "add")

        if (index > -1 && stakes) {

            let tempStakes = [...stakes]

            const last = cancel[index]
            const box = last.box

            if (last.target === "refresh") {
                tempStakes = initialStakes
            }
            else if (last.uuid) {
                list.forEach((item, ind) => {
                    if (item.uuid === last.uuid && item.type !== "remove") {
                        tempStakes[item.box].ante -= last.value
                        list[ind].type = "remove"
                        setTimeout(() => {
                            list[ind].removed = true
                        }, 500)
                    }
                })
            } else if (last.double) {
                list.forEach((item, ind) => {
                    if (item.double === last.double && item.type !== "remove") {
                        tempStakes[item.box][item.target] /= 2
                        list[ind].type = "remove"
                        setTimeout(() => {
                            list[ind].removed = true
                        }, 500)
                    }
                })
            }
            else if (last.target === 'ante') {
                if (tempStakes[box].ante - last.value >= 0) {
                    tempStakes[box].ante -= last.value
                    list[index].type = "remove"
                    setTimeout(() => {
                        list[index].removed = true
                    }, 500)

                }
            }
            else if (last.target === 'perfectpair') {
                if (tempStakes[box].perfectpair - last.value >= 0) {
                    tempStakes[box].perfectpair -= last.value
                    const ind = list.findLastIndex(e => e.type === "add" && e.target === "perfectpair")
                    list[ind].type = "remove"
                    setTimeout(() => {
                        list[ind].removed = true
                    }, 500)
                }
            }

            else if (last.target === 'twentyone') {
                if (tempStakes[box].twentyone - last.value >= 0) {
                    tempStakes[box].twentyone -= last.value
                    const ind = list.findLastIndex(e => e.type === "add" && e.target === "twentyone")
                    list[ind].type = "remove"
                    setTimeout(() => {
                        list[ind].removed = true
                    }, 500)
                }
            }

            else if (last.target === 'bust') {
                if (tempStakes[box].bust - last.value >= 0) {
                    tempStakes[box].bust -= last.value
                    const ind = list.findLastIndex(e => e.type === "add" && e.target === "bust")
                    list[ind].type = "remove"
                    setTimeout(() => {
                        list[ind].removed = true
                    }, 500)
                }
            }

            else if (last.target === 'crazyseven') {
                if (tempStakes[box].crazyseven - last.value >= 0) {
                    tempStakes[box].crazyseven -= last.value
                    const ind = list.findLastIndex(e => e.type === "add" && e.target === "crazyseven")
                    list[ind].type = "remove"
                    setTimeout(() => {
                        list[ind].removed = true
                    }, 500)
                }
            }


            setStakes(tempStakes)
            setList(list)
            if (volume) {
                sound.play('chip2', 0.2)
            }
        }
    }

    double = () => {

        const { boxPlayers, playerId, stakes, setStakes, total, list, setList, balance, game, volume } = this.props

        if (total * 2 > balance) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        let cnt = 0

        const uuid = uuidv4()

        let tempStakes = stakes
        tempStakes.forEach((stake, index) => {
            if (stake && stake.ante && boxPlayers && boxPlayers[index] && boxPlayers[index].playerId === playerId) {
                if (stake.ante * 2 <= game.max) {

                    list.push({ value: stake.ante, type: "add", target: "ante", place: `ante-${index}`, double: uuid, box: index })
                    stake.ante *= 2

                    if (stake.perfectpair) {
                        if (stake.perfectpair * 2 > game.maxPerfectPair) {
                            utils.toggleError(`${utils.translate("Maximum bid for PERFECT PAIR")} ${game.maxPerfectPair}`, "error", "maxbidPP")
                            return
                        }
                        list.push({ value: stake.perfectpair, type: "add", target: "perfectpair", place: `perfectpair-${index}`, double: uuid, box: index })
                        stake.perfectpair *= 2
                    }

                    if (stake.twentyone) {
                        if (stake.twentyone * 2 > game.maxTwentyOne) {
                            utils.toggleError(`${utils.translate("Maximum bid for 21+3")} ${game.maxTwentyOne}`, "error", "maxbidTO")
                            return
                        }
                        list.push({ value: stake.twentyone, type: "add", target: "twentyone", place: `twentyone-${index}`, double: uuid, box: index })
                        stake.twentyone *= 2
                    }

                    if (stake.bust) {
                        if (stake.bust > game.maxBust) {
                            utils.toggleError(`${utils.translate("Maximum bid for BUST")} ${game.maxBust}`, "error", "maxbidb")
                            return
                        }
                        list.push({ value: stake.bust, type: "add", target: "bust", place: `bust-${index}`, double: uuid, box: index })
                        stake.bust *= 2
                    }

                    if (stake.crazyseven) {
                        if (stake.crazyseven > game.maxCrazySeven) {
                            utils.toggleError(`${utils.translate("Maximum bid for CRAZY SEVEN")} ${game.maxCrazySeven}`, "error", "maxbidcs")
                            return
                        }
                        list.push({ value: stake.crazyseven, type: "add", target: "crazyseven", place: `crazyseven-${index}`, double: uuid, box: index })
                        stake.crazyseven *= 2
                    }

                    cnt += 1

                    if (volume) {
                        sound.play('sound', 0.2)
                    }

                }
            }
        })

        if (cnt) {
            setList(list)
            setStakes(tempStakes)
        }

    }


    refresh = () => {

        const { boxPlayers, playerId, last, setStakes, list, setList, balance, game, volume } = this.props

        let total = 0

        last.forEach((stake, index) => {
            if (stake && stake.ante && boxPlayers && boxPlayers[index] && boxPlayers[index].playerId === playerId) {
                total += stake.ante + stake.perfectpair + stake.twentyone + stake.bust + stake.crazyseven
            }
        })

        if (total > balance) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        list.push({ type: "add", target: "refresh" })

        setStakes(last)
        setList(list)

    }

    render = () => {

        const { selected, last, chips, total, boxPlayers, playerId } = this.props

        let lastTotal = 0

        last && Array.isArray(last) && last.forEach((stake, index) => {
            if (stake && stake.ante && boxPlayers && boxPlayers[index] && boxPlayers[index].playerId === playerId) {
                lastTotal += stake.ante
            }
        })

        const btnStyle = total ? { opacity: 1 } : { opacity: 0.5, cursor: 'default' }
        const refreshStyle = total === 0 && lastTotal > 0 ? { opacity: 1 } : { opacity: 0.5, cursor: 'default' }

        return (
            <div className="chips-container">

                <div onClick={() => this.clear()} className="chips-button" style={btnStyle}>
                    <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                    {utils.translate('Clear')}
                </div>

                <div onClick={() => this.cancel()} className="chips-button" style={btnStyle}>
                    <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                    {utils.translate('Cancel')}
                </div>

                <div className="chips-box">
                    {chips.map((chip, index) =>
                        <div onClick={() => this.setChip(chip.value, index)} key={`${index}`} className={`chip ${selected === index ? 'active' : 'disabled'}`}>
                            <Chip color={chip.color} value={chip.value} />
                        </div>
                    )}
                </div>

                <div onClick={() => this.double()} className="chips-button" style={btnStyle}>
                    <span>2x</span>
                    {utils.translate('Double')}
                </div>

                <div onClick={() => this.refresh()} className="chips-button" style={refreshStyle}>
                    <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                    {utils.translate('Repeat')}
                </div>

            </div>
        )
    }

}

export default Chips